<template>
  <a-form-model
    ref="form"
    :model="form"
    :label-col="{
      span: 0
    }"
    :rules="rules"
    :wrapperCol="{ span: 24 }"
  >
    <a-space class="select-space" :size="10">
      <a-form-model-item
        class="inputContainer"
        prop="key"
        style="margin-bottom: 0"
      >
        <simple-select
          v-model="form.key"
          :options="itemList.map(item => {
            return {
              label: item.name,
              key: item.key
            }
          })"
          :label-in-value="false"
          :disabled="!isCreate"
          :auto-select="false"
          style="width: 180px"
        ></simple-select>
      </a-form-model-item>

      <a-form-model-item
        class="inputContainer"
        prop="method"
        style="margin-bottom: 0"
      >
        <simple-select
          v-model="form.method"
          :options="methods"
          :label-in-value="false"
          :disabled="disabled"
          :auto-select="false"
          style="width: 120px"
        ></simple-select>
      </a-form-model-item>

      <a-form-model-item
        class="inputContainer"
        prop="condition"
        style="margin-bottom: 0"
      >
        <simple-select
          v-model="form.condition"
          :options="compareConditions.map(key => {
            return {
              label: $t(`compare_condition.${key}`),
              key: key
            }
          })"
          :label-in-value="false"
          :disabled="disabled"
          :auto-select="false"
          style="width: 120px"
        ></simple-select>
        <!-- <span class="label">判断条件</span> -->
      </a-form-model-item>

      <a-form-model-item
        class="inputContainer"
        prop="value"
        style="margin-bottom: 0"
      >
        <a-input-number
          id="value"
          v-model="form.value"
          :disabled="disabled"
          :min="0"
        />
        <span class="label">阈值</span>
      </a-form-model-item>

      <a-form-model-item
        class="inputContainer"
        prop="proportion"
        style="margin-bottom: 0"
      >
        <a-input-number
          id="proportion"
          v-model="form.proportion"
          :disabled="disabled"
          :min="0"
        />
        <span class="label">占比份额</span>
      </a-form-model-item>

      <a-form-model-item
        style="margin: 0 0 2px 0px"
      >
        <a-space
          v-if="isEdit || isCreate"
          :size="0"
          :class="{
            'btn-space' : true,
            'active-btn': true
          }"
        >
          <a-tooltip title="确认" placement="bottom">
            <a-button type="link" shape="circle" @click="handleOk">
              <a-icon type="check-circle" style="color: #0a9a06; font-size: 18px"/>
            </a-button>
          </a-tooltip>
          <a-popconfirm
            title="确认要删除吗？"
            ok-text="确认"
            cancel-text="取消"
            @confirm="handleDelete"
          >
            <a-tooltip title="删除" placement="bottom">
              <a-button type="link" shape="circle" @click="{}">
                <a-icon type="minus-circle" style="color: #f5222d; font-size: 18px"/>
              </a-button>
            </a-tooltip>
          </a-popconfirm>
          <a-tooltip v-if="!isCreate" title="取消" placement="bottom">
            <a-button type="link" shape="circle" @click="handleCancel">
              <a-icon type="close-circle" style="color: #bfbfbf; font-size: 18px"/>
            </a-button>
          </a-tooltip>
        </a-space>
        <a-space class="btn-space" v-else-if="!isCreate" :size="0">
          <a-tooltip title="编辑" placement="bottom">
            <a-button type="link" shape="circle" @click="isEdit = true">
              <a-icon type="edit" style="color: orange; font-size: 18px"/>
            </a-button>
          </a-tooltip>
        </a-space>
      </a-form-model-item>
    </a-space>
  </a-form-model>
</template>

<script>
import {
  createServiceHealthIndicator,
  updateServiceHealthIndicator,
  deleteServiceHealthIndicator,
  getServiceHealthIndicator
} from '@/api/service-health.js'
import { compareConditions } from '@/utils/const.js'
import SimpleSelect from '@/components/select/SimpleSelect.vue'

export default {
  name: 'FormItem',
  components: {
    SimpleSelect
  },
  props: {
    itemList: {
      type: Array
    },
    dimension: {
      type: Object
    },
    itemData: {
      type: Object
    },
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const methods = ['maximum', 'minimum', 'average', 'current'].map(value => {
      return {
        label: this.$t(`calculation_method.${value}`),
        value
      }
    })
    return {
      methods,
      compareConditions,
      form: this.itemData,
      isEdit: false,
      rules: {
        key: [
          {
            message: '请选择指标',
            required: true,
            trigger: 'change'
          }
        ],
        method: [
          {
            message: '请选择判断值',
            required: true,
            trigger: 'change'
          }
        ],
        condition: [
          {
            message: '请选择判断条件',
            required: true,
            trigger: 'change'
          }
        ],
        value: [
          {
            message: '请设置阈值',
            required: true,
            trigger: 'blur'
          }
        ],
        proportion: [
          {
            message: '请设置占比份额',
            required: true,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    disabled () {
      if (this.isCreate) return false
      else return !this.isEdit
    }
  },
  methods: {
    handleDelete () {
      if (this.isCreate) {
        this.$emit('cancelAdd')
      } else {
        deleteServiceHealthIndicator(this.itemData.id).then(res => {
          this.$message.success(res.message)
          this.isEdit = false
          this.$emit('refresh')
        })
      }
    },
    handleOk () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isCreate) {
            createServiceHealthIndicator(this.form).then(res => {
              this.$message.success(res.message)
              this.$emit('refresh')
              this.$emit('cancelAdd')
            }).catch(() => {})
          } else {
            const params = {
              method: this.form.method,
              value: this.form.value,
              condition: this.form.condition,
              proportion: this.form.proportion
            }
            updateServiceHealthIndicator(this.itemData.id, params).then(res => {
              this.$message.success(res.message)
              this.isEdit = false
              this.$emit('refresh')
            })
          }
        }
      })
    },
    handleCancel () {
      this.isEdit = false
      getServiceHealthIndicator(this.itemData.id).then(res => {
        this.form = res.data
      })
    }
  },
  watch: {
    itemData: {
      handler (v) {
        this.form = v
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.select-space {
  &:hover {
    .btn-space {
      opacity: 1;
    }
  }
  .inputContainer {
    position: relative;
    .label {
      position: absolute;
      top: -32px;
      left: 4px;
      font-size: 11px;
    }
    color: rgb(124, 124, 124);
  }

  .btn-space {
    opacity: 0;
    padding-top: 6px;
    transition: all .3s;
  }
  .active-btn {
    opacity: 1;
  }
}
</style>
